import { render, staticRenderFns } from "./_Category.vue?vue&type=template&id=63165f3d&"
import script from "./_Category.vue?vue&type=script&lang=js&"
export * from "./_Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports